/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class PolygonExportClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags PolygonExport
   * @summary Получить имя файла для экспорта полигона проекта в формате IRAP ASCII.
   * @request GET:/geofile-import/export/from_project/{projectId}/polygon/{polygonId}/irap_ascii_filename
   * @secure
   */
  polygonExportGetProjectPolygonIrapFileName = (
    projectId: string,
    polygonId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geofile-import/export/from_project/${projectId}/polygon/${polygonId}/irap_ascii_filename`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags PolygonExport
   * @summary Экспорт полигона из проекта в формате IRAP ASCII.
   * @request GET:/geofile-import/export/from_project/{projectId}/polygon/{polygonId}/to_irap_ascii
   * @secure
   */
  polygonExportExportPolygonFromProjectToIrap = (
    projectId: string,
    polygonId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/geofile-import/export/from_project/${projectId}/polygon/${polygonId}/to_irap_ascii`,
      method: 'GET',
      secure: true,
      ...params,
    })
}
